import React from "react";
import { Grid } from "@material-ui/core";
import RefreshIcon from "@material-ui/icons/Refresh";
import StyledActionButton from "./StyledActionButton";
import { COLORS } from "../styles/theme";

interface ResetWorkflowButtonProps {
  onReset: () => void;
  label?: string;
  style?: React.CSSProperties;
}

const ResetWorkflowButton: React.FC<ResetWorkflowButtonProps> = ({
  onReset,
  label = "Start New Ingestion",
  style,
}) => {
  return (
    <Grid item xs={12} style={{ marginTop: 24, ...style }}>
      <StyledActionButton
        label={label}
        onClick={onReset}
        color={COLORS.orange}
        startIcon={<RefreshIcon />}
      />
    </Grid>
  );
};

export default ResetWorkflowButton;
